<template>
  <div class="FullBox">
    <header class="section-header" v-if="hasHeader">
      <slot name="header"></slot>
    </header>
    <div class="flex" :class="{absoluteHeight: !hasHeader, fh: hasHeader}">
    
      <div class="mapBox">
        <slot v-if="blank">This is a blank FullBox</slot>
        <div class="section sctn-sm" v-else>
          <div class="corset">
            <slot>This is FullBox</slot>
          </div>
        </div>
      </div>
    
      <div class="actionBox" v-if="hasActions">
        <slot name="actions">This is FullBox</slot>
      </div>
    
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // name: String,
    blank: {
      type:     Boolean,
      default:  false
    }
  },
  computed: {
    hasHeader() {
      return this.$slots.header && this.$slots.header !== '' && this.$slots.header !== null
    },
    hasActions() {
      return this.$slots.actions && this.$slots.actions !== '' && this.$slots.actions !== null
    }
  }
  
}

</script>
<style lang="scss">
  
</style>
